export enum UserGroup {
  WISH_ADMIN = "WISH_ADMIN",
  AGENT_ADMIN = "AGENT_ADMIN",
}
